import { routes } from "@/constants/url";
import { cn } from "@/lib/utils";
import { Button, Typography } from "@backpac/monica";
import { useNavigate } from "react-router";

export function UnknownErrorMessage({ className, onReset }: { className?: string; onReset: () => void }) {
  const navigate = useNavigate();

  return (
    <div
      role="alert"
      className={cn("size-full flex flex-col items-center justify-center gap-30px text-center", className)}
    >
      <div className="mb-4">
        <Typography asChild size="xl" font="unbounded">
          <h1>Oops! Something went wrong</h1>
        </Typography>
        <Typography asChild size="sm">
          <p>Please try again.</p>
        </Typography>
      </div>
      <div className="flex flex-col gap-2">
        <Button onClick={onReset}>Try again</Button>
        <Button
          withArrow={true}
          variant="outlined"
          onClick={() => {
            onReset();

            // NOTE: ignore saved workspace id
            navigate(`${routes.WORKSPACE_NAVIGATOR.root}`);
          }}
        >
          Go home
        </Button>
      </div>
    </div>
  );
}
